import { DashboardOverview } from '@adminModels';
import { EventStatsDto, RoleUserStatsDto, VolunteerStatsDto } from '@klubovna/api-client';
import { createAction, props } from '@ngrx/store';

export const ADMIN_DASHBOARD_ID = '[Dashboard admin]';

export const loadDashboardOverview = createAction(
  ADMIN_DASHBOARD_ID + ' Load Dashboard Overview',
);

export const loadDashboardOverviewSuccess = createAction(
  ADMIN_DASHBOARD_ID + ' Load Dashboard Overview Success',
  props<{ overview: DashboardOverview }>(),
);

export const loadDashboardOverviewFailure = createAction(
  ADMIN_DASHBOARD_ID + ' Load Dashboard Overview Failure',
  props<{ error: string }>(),
);

export const loadUserStats = createAction(
  ADMIN_DASHBOARD_ID + ' Load User Stats',
);

export const loadUserStatsSuccess = createAction(
  ADMIN_DASHBOARD_ID + ' Load User Stats Success',
  props<{ stats: RoleUserStatsDto[] }>(),
);

export const loadUserStatsFailure = createAction(
  ADMIN_DASHBOARD_ID + ' Load User Stats Failure',
  props<{ error: string }>(),
);

export const loadEventStats = createAction(
  ADMIN_DASHBOARD_ID + ' Load Event Stats',
);

export const loadEventStatsSuccess = createAction(
  ADMIN_DASHBOARD_ID + ' Load Event Stats Success',
  props<{ stats: EventStatsDto }>(),
);

export const loadEventStatsFailure = createAction(
  ADMIN_DASHBOARD_ID + ' Load Event Stats Failure',
  props<{ error: string }>(),
);

export const loadVolunteerStats = createAction(
  ADMIN_DASHBOARD_ID + ' Load Volunteer Stats',
);

export const loadVolunteerStatsSuccess = createAction(
  ADMIN_DASHBOARD_ID + ' Load Volunteer Stats Success',
  props<{ stats: VolunteerStatsDto }>(),
);

export const loadVolunteerStatsFailure = createAction(
  ADMIN_DASHBOARD_ID + ' Load Volunteer Stats Failure',
  props<{ error: string }>(),
);

export const resetDashboardState = createAction(
  ADMIN_DASHBOARD_ID + ' Reset Dashboard State',
);
